import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NotificationsService} from 'angular2-notifications';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {
  CanComponentDeactivate,
  CanDeactivateGuardService
} from '../shared/modals/modal-popup/can-deactivate-gaurd.service';
import {ModalPopupService} from '../shared/modals/modal-popup/modal-popup.service';
import {
  CommonUtility,
  DataService,
  DateUtility,
  INVALID_EMAIL,
  Role,
  ServerConstantsService,
  USER_EXIST,
  WpProvider
} from '../shared';
import {ReferenceTableService} from '../reference-table.service';
import {ProviderService} from '../provider-management/provider-management.service';
import {User} from '../shared/model/User';
import {ProviderOffice} from '../shared/model/ProviderOffice';
import {UserInformation} from '../shared/model/UserInformation';
import {UserCounty} from '../shared/model/UserCounty';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {UserOffice} from '../shared/model/UserOffice';
import {ProviderCounty} from '../shared/model/ProviderCounty';
import {UserRoles} from '../shared/model/UserRoles';
import {UserRolesId} from '../shared/model/UserRolesId';
import {UserOfficeId} from '../shared/model/UserOfficeId';
import {UserCountyId} from '../shared/model/UserCountyId';
import {UserInformationId} from '../shared/model/UserInformationId';
import {StaffInfo} from '../shared/model/StaffInfo';
import {StaffManagementRequest} from "../shared/model/StaffManagementRequest";

@Component({
  selector: 'app-staff-management',
  templateUrl: './staff-management.component.html',
  styleUrls: ['./staff-management.component.scss']
})
export class StaffManagementComponent implements OnInit, CanComponentDeactivate {

  ServerConstants: any;
  sharedData: any;
  providers: any[] = [];
  counties: any[];
  providerOffices: any[] = [];
  countyMap: any;
  countyJson: any;
  providerRoles: any[] = [];
  stateWorkerRoles: any[] = [];

  role: Role;
  roleId: any;
  assignedTo: any;
  assignedToInd: any;
  countyCd: any;
  providerCountyCd: Array<any> = [];
  workerCounties: Array<any> = [];
  office: any;
  isNewUser: boolean;
  userId: any;
  email: any;
  isProvider: boolean;
  isWorker: boolean;
  officeCd: any;
  endDate: any;
  beginDate: any;
  providerId = '';

  required = true;
  providedCounties: any[] = [];
  minDateForEndDate: NgbDateStruct;
  staffManagement: StaffInfo;
  staffManagementClone: StaffInfo;

  roles: Role[];
  provider: any;
  isFocused = false;
  disableRB = false;
  userActionNotificationsMap: any;
  invalidEmailField = false;
  errorAptDateField: string = null;

  providerOffice: ProviderOffice;


  providerOfficesMngt: ProviderOffice[];
  providedCountiesMngt: ProviderCounty[];
  loaderFocus: Boolean = false;

  //roles: any[];
  providersMngt: any[];
  isChangeDetected: boolean;
  dropdownSettings: any = {};
  dropdownSettingsProv: any = {};

  userAlreadyExist = false;
  USER_EXIST = USER_EXIST;
  INVALID_EMAIL = INVALID_EMAIL;
  disableUserName = true;

  @ViewChild('resetBtn') resetBtn: ElementRef;
  @ViewChild('saveBtn') saveBtn: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('providerInput') providerInput: ElementRef;
  @ViewChild('emailField') emailField: ElementRef;
  @ViewChild('emailMsg') emailMsg: ElementRef;
  @ViewChild('labelText') labelText: ElementRef;

  staffManagementInfo: StaffManagementRequest;
  editUserId: number;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private providerService: ProviderService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService,
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    /*if (this.dataService.getSharedDataObject().get('providerOfficesMngt') == undefined) {
      this.router.navigate(['/admin/staff-management']);
    }*/
  }

  ngOnInit() {
    this.emailMsg.nativeElement.classList.add('d-none');
    this.dataService.globalAccess = true;
    this.sharedData = this.dataService.getSharedDataObject();
    this.role = new Role();
    this.providerOffice = new ProviderOffice;
    this.getRefTableData();

    /*this.providerId = this.sharedData.get('providerId');
    this.providerOfficesMngt = this.sharedData.get('providerOfficesMngt');
    this.providedCountiesMngt = this.sharedData.get('providerCountiesMngt');
    this.roles =  this.sharedData.get('rolesStaffMngt');
    this.providersMngt = this.sharedData.get('providerStaffMngt');
    this.staffManagement = this.sharedData.get('userStaffMngt');
    this.staffManagementClone = Object.assign({}, this.staffManagement);*/

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false,
    };

    this.dropdownSettingsProv = {
      singleSelection: true,
      idField: 'value',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false,
    };


    this.providerId = this.sharedData.get('providerId');
    this.isProvider = false;
    this.isWorker = false;


    if (this.providerId != null) {
      this.assignedToInd = 'P';
      this.disableRB = true;
      this.isProvider = true;
      this.roleId = '5';
    } else {
      //this.disableRB = true;
    }

    this.editUserId = this.sharedData.get('staffMgmtUserId');
    this.dataService.removeValueFromSharedDataMap('staffMgmtUserId');
    this.getStaffData(this.editUserId);
    /*if (this.staffManagement !== undefined || this.staffManagement != null) {
      //this.staffManagement.user.id = parseInt(this.userId, 10);
      this.isNewUser = false;
      this.loadStaff();
    } else {
      this.isNewUser = true;
      this.getLoadPageData();
      this.staffManagement = new StaffInfo();
      this.staffManagement.user = new User();
      this.staffManagement.userInformation = new UserInformation();
      this.staffManagement.userInformation.id = new UserInformationId();
      this.staffManagement.user.userCounties = [];
      const userCounty = new UserCounty();
      userCounty.id = new UserCountyId();
      this.staffManagement.user.userCounties.push(userCounty);
      this.staffManagement.userRoles = [];
    }*/
    
  }

  getStaffData(userId) {
    this.staffManagementInfo = new StaffManagementRequest();
    this.staffManagementInfo.userId = userId;
    this.http.post<StaffManagementRequest>(this.ServerConstants.SERVER_API_URL + '/admin/user-mgmt/loadStaff', this.staffManagementInfo).subscribe(
      (data: StaffManagementRequest) => {
        if (data == null || data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Staff Management', this.userActionNotificationsMap.ERROR);
        } else {
          this.staffManagementInfo = data;

          this.providerOfficesMngt = this.staffManagementInfo.providerOffices;
          this.providedCountiesMngt = this.staffManagementInfo.providerCounties;
          this.roles = this.staffManagementInfo.roles;
          this.providersMngt = this.staffManagementInfo.providers;
          this.staffManagement = this.staffManagementInfo.staffInfo;
          this.staffManagementClone = Object.assign({}, this.staffManagement);

          if (this.staffManagement !== undefined && this.staffManagement !== null) {
            this.isNewUser = false;
            this.loadStaff();
          } else {
            this.isNewUser = true;
            this.getLoadPageData();
            this.staffManagement = new StaffInfo();
            this.staffManagement.user = new User();
            this.staffManagement.userInformation = new UserInformation();
            this.staffManagement.userInformation.id = new UserInformationId();
            this.staffManagement.user.userCounties = [];
            const userCounty = new UserCounty();
            userCounty.id = new UserCountyId();
            this.staffManagement.user.userCounties.push(userCounty);
            this.staffManagement.userRoles = [];
          }
        }
      },
      response => {
        this.notificationService.error('Staff Management', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  loadStaff() {
    this.getLoadPageData();

    //Load user data
    if (this.staffManagement.user != null) {
      this.beginDate = this.dateUtil.convertDateFromServer( this.staffManagement.user.beginDt );

      //If provider
      if (this.staffManagement.user.providerId != null) {
        this.assignedToInd = 'P';
        this.isProvider = true;
        this.assignedTo = this.staffManagement.user.providerId + '';
        this.loadCountiesForProvider(this.assignedTo );

        /*If provider, search in UserOffice table*/
        if (this.staffManagement.userOffice != null) {
          this.countyCd = this.staffManagement.userOffice.id.office.serviceCounty + '';

          for (const county of this.providedCounties) {
            if (this.countyCd === county.value) {
              this.providerCountyCd.push( county );
            }
          }

          this.loadOffices(this.countyCd);
          this.officeCd = this.staffManagement.userOffice.id.office.id + '';
          setTimeout(() => {
            this.loadAddressDetails(this.officeCd);
          });
        }
        this.endDate = this.dateUtil.convertDateFromServer(this.staffManagement.user.endDt);

      } else {
        this.assignedToInd = 'C';
        this.isProvider = false;
        this.disableUserName = false;
        this.workerCounties = [];
        for (const county of this.staffManagement.user.userCounties) {
          for (const countyDef of this.counties) {
            if ((county.id.serviceCounty + '') === countyDef.value) {
              this.workerCounties.push({ value: countyDef.value, name: countyDef.name });
            }
          }
        }
      }

      if (this.staffManagement.userRoles != null) {
        this.roleId = this.staffManagement.userRoles[0].id.role.id + '';
      }

      // Account Details
      if (this.staffManagement.userInformation != null) {
        this.email = this.staffManagement.userInformation.email;
      } else {
        this.staffManagement.userInformation = new UserInformation();
      }
    }
  }

  getLoadPageData() {

    this.providers = [];
    this.stateWorkerRoles = [];
    this.providerRoles = [];

    /*Get Providers*/
    this.providers.push({'name': 'Pick a Provider', 'value': undefined});
    const providersList: WpProvider[] = this.providersMngt;
    if (providersList != null) {
      for (const p of providersList) {
        this.providers.push({'name': p.providerName, 'value': p.id + ''});
      }
    }

    /* Get Roles*/
    const roleList = this.roles;

    this.stateWorkerRoles.push({'name': 'Pick Assigned Role', 'value': undefined});
    this.providerRoles.push({'name': 'Pick Assigned Role', 'value': undefined});

    if (roleList != null) {
      for (const r of roleList) {
        if (r.name === 'Provider') {
          this.providerRoles.push({'name': r.name, 'value': r.id + ''});
        } else {
          this.stateWorkerRoles.push({'name': r.name, 'value': r.id + ''});
        }

      }
    }
  }

  dataChanges() {
    this.isChangeDetected = true;
  }
  restrict(event){
    if(event.key !== '.' && event.key !== '@'){
      return true;
    }
    else{
      return false;
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  }

  save() {
    this.isChangeDetected = false;
    if (this.isNewUser) {
      /*
      *  New Record
      * */

      if (this.validateEmail()) {
        this.notificationService.warn('Staff Management', this.INVALID_EMAIL);
        return;
      }

      if (this.userAlreadyExist) {
        this.notificationService.warn('Staff Management', 'Username Already Exists.');
        this.emailField.nativeElement.classList.remove('ng-valid');
        this.emailField.nativeElement.classList.add('ng-invalid');
        this.userAlreadyExist = true;
        return;
      }

      /*Set User Roles and User Counties for new Record*/
      //this.staffManagement.user.userRoles = [];
      this.staffManagement.userRoles = [];
      for (const role of this.roles) {
        if (role.id == this.roleId) {
          const userRole = new UserRoles();
          userRole.id = new UserRolesId();
          userRole.id.role = role;
          //this.staffManagement.user.userRoles.push( userRole);
          this.staffManagement.userRoles.push(userRole);
          break;
        }
      }
      /* Set User County or OfficeUser*/
      if (this.isProvider) {
        this.staffManagement.user.providerId = this.assignedTo;
        this.staffManagement.user.endDt = this.dateUtil.convertDateForServer(this.endDate);

        this.staffManagement.userOffice = new UserOffice();
        this.staffManagement.userOffice.id = new UserOfficeId();
        this.staffManagement.userOffice.id.office = new ProviderOffice();
        //this.staffManagement.userOffice.id.office.id = parseInt(this.officeCd);
        //Set Office
        for (const office of this.providerOfficesMngt) {
          if (this.officeCd === office.id + '') {
            this.staffManagement.userOffice.id.office = office;
          }
        }
        this.staffManagement.user.userCounties = null;

      } else {
        this.staffManagement.user.providerId = null;
        this.staffManagement.userOffice = null;
        this.staffManagement.user.endDt = null;
        this.staffManagement.user.userCounties = [];
        //console.log(this.workerCounties);
        for (const county of  this.workerCounties) {
          const userCounty: UserCounty = new UserCounty();
          userCounty.id = new UserCountyId();
          userCounty.id.serviceCounty = parseInt(county.value);
          this.staffManagement.user.userCounties.push(userCounty);
        }
        this.staffManagement.userOffice = null;
      }

      this.staffManagement.user.tempPassword = null;
      this.staffManagement.user.tempPasswordSw = null;
      this.staffManagement.userInformation.id = new UserInformationId();

    } else {
      /*
      *  Existing Record
      * */
      if (this.isProvider) {
        this.staffManagement.user.userCounties = [];
        const userCounties = this.staffManagement.user.userCounties;
        this.staffManagement.user.userCounties = [];

          for (const uCounty of userCounties) {
            if ((uCounty.id.serviceCounty) == this.providerCountyCd[0].value) {
              this.staffManagement.user.userCounties.push(uCounty);
            }
          }
        this.staffManagement.user.providerId = this.assignedTo;
        this.staffManagement.user.endDt = this.dateUtil.convertDateForServer(this.endDate);
        for (const office of this.providerOfficesMngt) {
          if (this.officeCd === office.id + '') {
            if (this.staffManagement.userOffice == null) {
              this.staffManagement.userOffice = new UserOffice();
              this.staffManagement.userOffice.id = new UserOfficeId();
            }
            this.staffManagement.userOffice.id.office = office;
            break;
          }
        }
      } else {
        this.staffManagement.user.providerId = null;
        this.staffManagement.userOffice = null;
        this.staffManagement.user.endDt = null;
        this.staffManagement.user.userCounties;

        const userCounties = this.staffManagement.user.userCounties;
        let alreadyExisted = false;
        this.staffManagement.user.userCounties = [];

        for (const county of  this.workerCounties) {
          //Add the ones already existed
          alreadyExisted = false;
          for (const uCounty of userCounties) {
            if ((uCounty.id.serviceCounty + '') === county.value) {
              this.staffManagement.user.userCounties.push(uCounty);
              alreadyExisted = true;
            }
          }
          if (!alreadyExisted) {
            const userCounty: UserCounty = new UserCounty();
            userCounty.id = new UserCountyId();
            userCounty.id.serviceCounty = parseInt(county.value);
            userCounty.id.userId = this.staffManagement.user.id;
            this.staffManagement.user.userCounties.push(userCounty);
          }
        }
        this.staffManagement.userOffice = null;
      }

      /*Set User Roles and User Counties for an existing record*/
      for (const role of this.roles) {
        if (role.id == this.roleId) {
          //this.staffManagement.user.userRoles[0].id.role = role;
          this.staffManagement.userRoles[0].id.role = role;
          break;
        }
      }
    }

    this.staffManagement.userInformation.email = this.email;
    this.staffManagement.user.beginDt = this.dateUtil.convertDateForServer(this.beginDate);
    this.staffManagement.user.username = this.staffManagement.user.username.toLowerCase();

    this.http.post<StaffInfo>(this.ServerConstants.SERVER_API_URL + '/admin/user-mgmt/saveStaffInfo', this.staffManagement).subscribe(
      (data: StaffInfo) => {
        if (data == null || data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Save Staff Management', this.userActionNotificationsMap.ERROR);
          setTimeout(() => this.fileInput.nativeElement.focus(), 0);
          this.fileInput.nativeElement.click();
        } else {
          this.staffManagement = data;
          if (this.staffManagement.user.id != null) {
            this.notificationService.success('Save Staff Management', this.userActionNotificationsMap.UPDATE);
            setTimeout(() => this.headerText.nativeElement.focus(), 0);
            this.headerText.nativeElement.click();
            this.goToSummary();
          }
        }
      },
      response => {
        this.notificationService.error('Save Staff Management', this.userActionNotificationsMap.ERROR);
        setTimeout(() => this.fileInput.nativeElement.focus(), 0);
        this.fileInput.nativeElement.click();
      },
      () => {
      });

  }

  goToSummary() {
    this.router.navigate(['admin/staff-management']);
  }

  reset() {
    //TODO: Check how to make reset

    if (this.isNewUser) {
      this.staffManagement = new StaffInfo();
      this.staffManagement.user = new User();
      this.staffManagement.user.userCounties = [];
      this.staffManagement.userRoles = [];
      this.staffManagement.userInformation = new UserInformation();

      this.countyCd = undefined;
      this.roleId = undefined;
      this.email = '';
      this.beginDate = null;
      this.endDate = null;
      this.assignedToInd = null;

      this.providerOffice = new ProviderOffice();

      if (this.providerId != null) {
        this.assignedToInd = 'P';
        this.roleId = '5';
        this.disableRB = true;
        this.isProvider = true;

      } else {
        this.isProvider = false;
        this.isWorker = false;
      }

      //this.isWorker = false;
    } else {
      this.staffManagement = null;
      this.staffManagement = this.staffManagementClone;
      this.isNewUser = false;
      this.providerOffice = new ProviderOffice();
      this.loadStaff();
    }

  }

  getRefTableData() {
    this.counties = [];
    this.counties = this.data.getValueFromSharedDataMap('COUNTIES');
    this.countyMap = this.commonUtil.createMapFromList(this.counties);
    this.countyJson = this.commonUtil.createNativeMapFromList(this.counties);
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
  }


  setAvailable(indicator) {
    if (indicator != null) {
      this.assignedTo = null;
      //if(this.isNewUser){
      if (indicator === 'C') {
        this.workerCounties = [];
        this.isWorker = true;
        this.isProvider = false;
        this.disableUserName = false;
        this.staffManagement.user.username = '';
      } else if (indicator === 'P') {
        this.isProvider = true;
        this.isWorker = false;
        this.roleId = '5';
        this.disableUserName = true;
        this.staffManagement.user.username = this.email;
      }
    }
  }


  loadCountiesForStateWorker(event) {
    this.countyCd = undefined;
    this.roleId = undefined;
    this.counties = [];
    this.endDate = null;
    this.counties = this.data.getValueFromSharedDataMap('COUNTIES');
    this.disableUserName = false;
  }

  loadCountiesForProvider(providerId) {
    if (providerId != null) {
      this.countyCd = undefined;
      this.providedCounties = [];
      this.officeCd = undefined;
      this.providerOffices = [];
      this.providerCountyCd = [];
      /* Get Provider Counties*/
      const providerCounties = this.providedCountiesMngt;
      this.providedCounties.push({'name': 'Pick an Option', 'value': undefined});

      if (providerCounties != null) {
        for (const county of providerCounties) {
          if (providerId === (county.provider.id + '')) {
            if(this.convertCode(this.countyMap, county.serviceCounty + '') !== undefined){
              this.providedCounties.push({
                'name': this.convertCode(this.countyMap, county.serviceCounty + ''),
                'value': county.serviceCounty + ''
              });
            }
            this.providedCounties.sort();
            this.providedCounties.sort(function(a, b){
              var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase()
              if (nameA < nameB) //sort string ascending
                return -1
              if (nameA > nameB)
                return 1
              return 0 //default return value (no sorting)
            });
          }
        }
      }
    }
  }

  loadOffices(providerCountiesCd) {
    //this.providerOffice = new ProviderOffice();
    this.providerOffice = new ProviderOffice();
    if (providerCountiesCd != null) {
      const providerOffices = this.providerOfficesMngt;
      this.providerOffices = [];
      this.providerOffices.push({'name': 'Pick an Option', 'value': undefined});

      //provider.id = assignedTo
      for (const countyId of providerCountiesCd) {
        if (providerOffices != null) {
          for (const office of providerOffices) {
            if ((countyId.value === (office.serviceCounty + '')) &&
              this.assignedTo === (office.provider.id + '')
            ) {
              this.providerOffices.push({'name': office.officeName, 'value': office.id + ''});
            }
          }
        }
      }
    }
  }

  loadAddressDetails(officeId) {
    this.providerOffice = new ProviderOffice();
    if (officeId != null) {
      const providerOffices = this.providerOfficesMngt;
      if (providerOffices != null) {
        for (const office of providerOffices) {
          if (officeId === (office.id + '')) {
            this.providerOffice = office;
            break;
          }
        }
      }
    }
  }

  populateUsername(username) {
    if (this.isNewUser) {
      if (username != null) {
        this.staffManagement.user.username = username;
      }
    }
  }

  validEndDate(endDate) {
    if (this.beginDate != null) {
      if (endDate != null) {
        const end = new Date(endDate.year, endDate.month - 1, endDate.day);
        const startDate = new Date(this.beginDate.year,
          this.beginDate.year.month - 1,
          this.beginDate.day);
        if (end < startDate) {
          this.errorAptDateField = 'Please select a date after start day';
        } else {
          this.errorAptDateField = null;
        }
      }
    } else {
      this.errorAptDateField = 'Please select a date after start day';
      this.endDate = null;
    }
  }

  setMinValidDates(beginDate) {
    if (beginDate != null) {
      const startDate = new Date(beginDate.year, beginDate.month - 1, beginDate.day);
      const todayDate = new Date();
      let resultDate;

      if (startDate <= todayDate) {
        resultDate = todayDate;
      } else {
        resultDate = startDate;
      }
      this.minDateForEndDate = {
        month : resultDate.getMonth() + 1,
        day : resultDate.getDate(),
        year : resultDate.getFullYear()
      };
    }
  }

  validateEmail() {
    const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    this.invalidEmailField = true;
    if (this.email !== null && this.email !== undefined) {
      if (!regExp.test(String(this.email).toLowerCase())) {
        this.invalidEmailField = true;
        this.emailField.nativeElement.classList.remove('ng-valid');
        this.emailField.nativeElement.classList.add('ng-invalid');
        this.emailMsg.nativeElement.classList.add('d-block');
        this.emailMsg.nativeElement.classList.remove('d-none');
        this.userAlreadyExist = false;
      } else {
        this.invalidEmailField = false;
        this.emailField.nativeElement.classList.remove('ng-invalid');
        this.emailField.nativeElement.classList.add('ng-valid');
        this.emailMsg.nativeElement.classList.remove('d-block');
        this.emailMsg.nativeElement.classList.add('d-none');
      }
    } else {
      this.invalidEmailField = true;
    }
    return this.invalidEmailField;
  }

  validateUserExist(event) {
    if (this.email === null || this.email === undefined || this.invalidEmailField) {
      return;
    }
    event.srcElement.blur();
    event.preventDefault();
    this.http.post<any>(this.ServerConstants.SERVER_API_URL + '/admin/user-mgmt/validateUserExists', this.email).subscribe(
      (val) => {
        if (val == null || val.hasOwnProperty('errorCode')) {
          this.notificationService.error('Staff Management', this.userActionNotificationsMap.ERROR);
        } else {
          const userExists = val;

          if (userExists) {
            this.notificationService.warn('Staff Management', 'Username Already Exists.');
            this.emailField.nativeElement.classList.remove('ng-valid');
            this.emailField.nativeElement.classList.add('ng-invalid');
            this.userAlreadyExist = true;
          } else {
            this.emailField.nativeElement.classList.remove('ng-invalid');
            this.emailField.nativeElement.classList.add('ng-valid');
            this.userAlreadyExist = false;
          }
        }
      },
      response => {
        this.notificationService.error('Staff Management', this.userActionNotificationsMap.ERROR);
      },
      () => {
        this.focusLabelText(event);
      });
    setTimeout(() => {
      this.focusLabelText(event);
    }, 0);

  }

  convertCode(myMap, code) {
    if (myMap != undefined) {
      return myMap.get(code);
    }
  }

  onItemDeselect(deselectStatus) {

    this.workerCounties.forEach( (status, index) => {
      if (status === deselectStatus) {
        this.workerCounties.splice(index, 1);
      }
    });
    event.stopPropagation();
  }

  onItemSelect(item: any) {
    this.isFocused = false;
  }

  onSelectAll(items: any) {
    for (const item of items) {
      this.onItemSelect(item);
    }
    this.isFocused = false;
  }

  /*ngOnDestroy() {
    this.dataService.removeValueFromSharedDataMap('providerOfficesMngt');
    this.dataService.removeValueFromSharedDataMap('providerCountiesMngt');
    this.dataService.removeValueFromSharedDataMap('rolesStaffMngt');
    this.dataService.removeValueFromSharedDataMap('providerStaffMngt');
    this.dataService.removeValueFromSharedDataMap('userStaffMngt');
  }*/

  focusHeader(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  focusProvider(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.providerInput.nativeElement.focus(), 0);
      this.providerInput.nativeElement.click();
    }
  }

  focusEmail(e: KeyboardEvent) {
    this.loaderFocus = true;
  }

  focusLabelText(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.labelText.nativeElement.focus(), 0);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/staff-management/staff-management.component.ts